<template>
  <div class="user-information">
    <div class="user-information__email">
      {{ $t('user_operations.email_address') }}
      <p>{{ user.email }}</p>
    </div>

    <div class="user-information__details">
      <div class="user-information__detail">
        {{ $t('user_operations.full_name') }}
        <p>{{ userVerified }}</p>
      </div>
      <div class="user-information__detail">
        {{ $t('user_operations.phone_number') }}
        <p>{{ user.contact_number }}</p>
      </div>
      <div class="user-information__detail">
        {{ $t('user_operations.last_seen') }}
        <p>{{ lastSeen }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { formatDateLongMonth } from '@/functions/date_format_helpers';

const props = defineProps({
  user: { type: Object, required: true },
});

const userVerified = computed(() => {
  return props.user.first_name ? `${props.user.first_name} ${props.user.last_name}` : `-${props.user.email}`;
});

const lastSeen = computed(() => {
  return props.user.last_sign_in_at ? formatDateLongMonth(props.user.last_sign_in_at) : '-';
});
</script>

<style scoped lang="scss">
@import '@/stylesheets/global';

.user-information {
  width: 100%;

  p {
    color: map-get($foreground-color, light);
    font-weight: 500;
  }

  &__email {
    p {
      margin-bottom: bu(3);
    }
  }

  &__details {
    display: flex;
  }

  &__detail {
    flex: 1;
    &:nth-child(2) {
      padding: 0 bu(1);
    }
  }
}
</style>
